var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_vm._t("default")],2),(_vm.$slots['tabs-end'])?_c('div',{staticClass:"tab-content"},[_vm._t("tabs-end")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }